var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('json-viewer',{attrs:{"value":_vm.value,"expand-depth":5,"copyable":"","boxed":"","sort":""}})}
var staticRenderFns = []

export { render, staticRenderFns }